var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { QuestionComponent, QuestionProps } from '@declaration/question';
import { FIRE_BEGIN_LOCATION_HOUSE_OPTIONS } from '@declaration/constants/fireDamageConstants';
import QuestionPanel from '@declaration/components/UI/QuestionPanel.vue';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
const claim = namespace('claim');
const qualification = namespace('qualification');
const contract = namespace('contract');
let FireCauseLocationHouseQuestion = class FireCauseLocationHouseQuestion extends QuestionComponent {
    updateClaim(fireLocationHouse) {
        this.updateAndSaveFireDamageQualification({
            qualificationPayload: {
                fireLocationHouse,
            },
            step: this.step,
        });
    }
    get panelTitle() {
        return this.$tc('claim.qualification.fire_cause_location_house.title');
    }
    get sidebarTitle() {
        const key = 'claim.qualification.fire_cause_location_house.sidebar_title';
        return this.$te(key) ? this.$tc(key) : this.panelTitle;
    }
    get answer() {
        if (!this.fireDamageQualification.fireLocationHouse) {
            return null;
        }
        return FIRE_BEGIN_LOCATION_HOUSE_OPTIONS[this.fireDamageQualification.fireLocationHouse]
            ? this.$tc(FIRE_BEGIN_LOCATION_HOUSE_OPTIONS[this.fireDamageQualification.fireLocationHouse]
                .answerTradKey)
            : null;
    }
    get fireCauseLocationHouseOptions() {
        return Object.values(FIRE_BEGIN_LOCATION_HOUSE_OPTIONS);
    }
};
__decorate([
    claim.State('isUpdatingClaim')
], FireCauseLocationHouseQuestion.prototype, "isUpdatingClaim", void 0);
__decorate([
    qualification.State('qualification')
], FireCauseLocationHouseQuestion.prototype, "fireDamageQualification", void 0);
__decorate([
    qualification.Action('updateAndSaveQualification')
], FireCauseLocationHouseQuestion.prototype, "updateAndSaveFireDamageQualification", void 0);
__decorate([
    contract.State('selectedContract')
], FireCauseLocationHouseQuestion.prototype, "selectedContract", void 0);
FireCauseLocationHouseQuestion = __decorate([
    Component({
        components: { RadioPrimaryButton, QuestionPanel },
        props: QuestionProps,
    })
], FireCauseLocationHouseQuestion);
export default FireCauseLocationHouseQuestion;
